import { render, staticRenderFns } from "./AdministrativeModal.vue?vue&type=template&id=7b268859&"
import script from "./AdministrativeModal.vue?vue&type=script&lang=js&"
export * from "./AdministrativeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports